<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="450px"
      transition="dialog-transition"
    >
      <v-sheet>
        <v-toolbar dark class="primary">
          <v-btn
            icon
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Datos de la cuenta</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-text-field
            v-model="numero"
            placeholder="Ingrese un número de cuenta"
            label="Número de cuenta"
            :rules="rules.numero"
            prepend-icon="mdi-card-account-details"
            color="primary"
            type="text"
            ref="inputNumero"
          ></v-text-field>
          <v-text-field
            v-model="descripcion"
            placeholder="Ingrese descripcion de la cuenta"
            label="Descripcion"
            :rules="rules.descripcion"
            prepend-icon="mdi-text-short"
            color="primary"
            ref="inputDescripcion"
          ></v-text-field>
          <v-switch
            ref="inputToleranciaSi"
            v-model="toleranciaSi"
            label="Habilitar dias de tolerancia personalizado para esta cuenta"
          ></v-switch>
          <v-text-field
            ref="inputTolerancia"
            v-model="tolerancia"
            :disabled="!toleranciaSi"
            placeholder="Ingrese dias de tolerancia"
            label="Dias de tolerancia"
            prepend-icon="mdi-calendar"
            type="number"
            color="primary"
          >
          </v-text-field>
          <v-switch
            ref="inputSwitchCierre"
            v-model="switchCierre"
            label="Cierre. Se deshabiltan las operaciones sobre la cuenta y se establece una fecha de cierre."
          ></v-switch>
          <v-footer>
            <v-btn
              :disabled="!updatable"
              color="primary"
              @click="onSubmit"
              :loading="loading"
            >
              Actualizar
            </v-btn>
          </v-footer>
        </v-container>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import KilosInput from '@/components/KilosInput'
export default {
  name: 'CuentasEditComponent',
  components: {
    'kilos-input': KilosInput
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      valid: false,
      toleranciaSi: false,
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeyboard);
    this.onClearEdited()
    this.onClearSelected()
  },
  created () {
    window.addEventListener('keydown', this.handleKeyboard);
  },
  computed: {
    ...mapGetters('Cuentas', ['edited', 'rules', 'loading', 'updatable']),
    id () {
      return this.edited.id
    },
    dialog: {
      get () {
        return this.selected
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    numero: {
      get () {
        return this.edited.numero
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          numero: value
        })
      }
    },
    descripcion: {
      get () {
        return this.edited.descripcion
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          descripcion: value
        })
      }
    },
    tolerancia: {
      get () {
        return this.edited.tolerancia
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          tolerancia: value
        })
      }
    },
    switchCierre: {
      get () {
        return this.edited.cierre ? true : false
      },
      set (value) {
        var cierreAux = null
        if (value === true) cierreAux = this.$moment().format('YYYY-MM-DD HH:mm:ss')
        this.setEdited({
          ...this.edited,
          cierre: cierreAux
        })
      }
    },
  },
  watch: {
    toleranciaSi(newVal) {
      if(!newVal) {
        this.tolerancia = null
      }
    },
    id(newVal, oldVal) {
      if(newVal > 0 && newVal != oldVal) {
        this.toleranciaSi = this.tolerancia >= 0 ? this.tolerancia : null
      }
    }
  },
  methods: {
    ...mapActions('Cuentas', ['onUpdate', 'onClearEdited', 'onClearSelected']),
    ...mapMutations('Cuentas', ['setEdited']),
    onSubmit(event) {
      event.preventDefault()
      if (this.updatable) {
        this.onUpdate().then(response => {
          this.$emit('change', false)
        })
      }
    },
    onClose (event) {
      event.preventDefault()
      this.dialog = false
    },
    handleKeyboard(event) {
      // event.preventDefault()
      if(event.key == '1' && event.altKey) {
        //Focus v-text-field numero
        event.preventDefault()
        if (this.$refs.inputNumero) {
          this.$refs.inputNumero.focus()
        }
      }
      else if(event.key === '2' && event.altKey) {
        event.preventDefault()
        if (this.$refs.inputDescripcion) {
          this.$refs.inputDescripcion.focus()
        }
      }
      else if(event.key === '3' && event.altKey) {
        event.preventDefault()
        this.toleranciaSi = !this.toleranciaSi;
      }
      else if(event.key === '4' && event.altKey) {
        event.preventDefault()
        if (this.$refs.inputTolerancia) {
          this.$refs.inputTolerancia.focus()
        }
      }
      else if(event.key === '5' && event.altKey) {
        event.preventDefault()
        this.switchCierre = !this.switchCierre;
      }
      else if(event.key === 'Enter' && event.altKey) {
        this.onSubmit(event);
      }
    },
  },
}
</script>
